import { Button, Form, Input, Modal } from "antd";
// import { useDispatch } from "react-redux";
import TextArea from "antd/es/input/TextArea";
import { changeLoader } from "../../redux/reducers/loader";
import * as Validation from "../../utils/helper/validation";
import * as Apis from "../../utils/helper/enum";
import { useDispatch } from "react-redux";
import globalRequest from "../../utils/global/globalRequest";
import toast from "react-hot-toast";
import { useEffect, useState } from "react";

const Deductions = ({ isOpen, onCancel, onOk, orderDetailData }) => {
  console.log(orderDetailData);
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  // const [formData] = useState({
  //   reason: "",
  //   vendor_deduction_amt: null,
  //   pickupvendor_deduction_amt: null,
  // });
  const [vendorDetail, setVendorDetail] = useState({});
  const [pickupVendorDetail, setpickupVendorDetail] = useState({});

  useEffect(() => {
    for (let order of orderDetailData.orderDetails) {
      if (order.vendorId === orderDetailData.vendorId) setVendorDetail(order.vendorDetails.vendorDetail);
      if (orderDetailData.pickupVendorId && orderDetailData.pickupVendorId > 0 && orderDetailData.pickupVendorId === order.vendorId)
        setpickupVendorDetail(order.vendorDetails.vendorDetail);
    }
  }, [orderDetailData]);

  const handleSubmit = async (values) => {
    // const values = await form.validateFields();
    // console.log("values", values);
    // return false;

    let insertData = {
      order_id:orderDetailData?.id,
      priceDetails: orderDetailData?.priceDetails,
      reason: values?.reason,
      vendor_deduction: values?.vendor_deduction_amt,
      pickupvendor_deduction: values?.pickupvendor_deduction_amt ? values?.pickupvendor_deduction_amt : 0,
    };

    dispatch(changeLoader(true));
    try {
      let url = Apis?.ORDERS?.ADD_DEDUCTION;
      let method = "post";
      let response = await globalRequest(url, method, insertData, {}, true);
      let apiResponse = response?.data;
      if (response?.status === 200) {
        let msg = "Deduction has been successfully processed.";
        toast.success(msg, {
          duration: 2000,
        });
        onOk();
      } else {
        toast.error(apiResponse?.message);
      }
    } catch (e) {
      toast.error(e?.message);
    }
    dispatch(changeLoader(false));
  };

  return (
    <>
      <Modal title="Deductions" centered open={isOpen} onCancel={onCancel} width={360} footer={null}>
        <Form
          form={form}
          onFinish={handleSubmit}
          layout="vertical"
          style={{
            maxWidth: 1000,
            width: "100%",
          }}
          initialValues={{
            remember: true,
          }}
          autoComplete="off"
        >
          <div>
            <div className="grid grid-cols-1 sm:grid-cols-1 gap-x-6">
              <Form.Item
                label="Deductions Amount for Seller"
                name="vendor_deduction_amt"
                rules={[
                  {
                    required: true,
                    message: "Please enter Deductions Amount for Seller.",
                  },
                  {
                    validator: (_, value) =>
                      !value || /^\d+(\.\d{1,2})?$/.test(value)
                        ? Promise.resolve()
                        : Promise.reject(new Error("Only numeric values (up to 2 decimal places) are allowed.")),
                  },
                ]}
              >
                <Input
                  size="large"
                  maxLength={10}
                  addonAfter="SAR"
                  // value={formData?.vendor_deduction_amt}
                  onChange={(e) => {
                    form.setFieldValue("vendor_deduction_amt", e.target.value);
                  }}
                />
              </Form.Item>

              {Object.keys(pickupVendorDetail).length > 0 ? (
                <Form.Item
                  label="Deductions Amount for Host"
                  name="pickupvendor_deduction_amt"
                  rules={[
                    {
                      required: true,
                      message: "Please enter Deductions Amount for Host.",
                    },
                    {
                      validator: (_, value) =>
                        !value || /^\d+(\.\d{1,2})?$/.test(value)
                          ? Promise.resolve()
                          : Promise.reject(new Error("Only numeric values (up to 2 decimal places) are allowed.")),
                    },
                  ]}
                >
                  <Input
                    size="large"
                    maxLength={50}
                    addonAfter="SAR"
                    onChange={(e) => {
                      form.setFieldValue("pickupvendor_deduction_amt", e.target.value);
                    }}
                  />
                </Form.Item>
              ) : null}

              <Form.Item
                label="Reason"
                name="reason"
                rules={[
                  {
                    required: true,
                    message: "Please enter Reason.",
                  },
                  {
                    max: 200,
                    message: "Maximum 200 characters",
                  },
                ]}
              >
                <TextArea
                  rows={4}
                  maxLength={200}
                  onChange={(e) => {
                    form.setFieldValue("reason", e.target?.value?.trimStart());
                    // setFormData((prevData) => ({
                    //   ...prevData,
                    //   reason: e.target?.value?.trimStart(),
                    //   reasonErr: "",
                    // }));
                  }}
                />
              </Form.Item>
            </div>
          </div>
          <div className="flex justify-end gap-3">
            <Button className="w-[100px] h-[39px]" onClick={onCancel}>
              Cancel
            </Button>
            <Button
              type="primary"
              className="w-[100px] h-[39px]"
              htmlType="submit"
              // onClick={() => handleSubmit()}
            >
              Save
            </Button>
          </div>
        </Form>
      </Modal>
    </>
  );
};
export default Deductions;
